import { TriggerType } from '@polybank/shared';
/**
 * Converts active TransactionFilters into rule trigger presets.
 *
 * Supported mappings:
 * - searchQuery + searchMode → DESCRIPTION_CONTAINS / DESCRIPTION_NOT_CONTAINS
 * - accountFilter → ACCOUNT_IS (one trigger per account)
 * - amountRange.min → AMOUNT_GREATER_EQUAL
 * - amountRange.max → AMOUNT_LESS_EQUAL
 *
 * - dateRange.from + to → DATE_BETWEEN (comma-separated)
 * - dateRange.from only → DATE_STARTING_FROM
 * - dateRange.to only → DATE_UNTIL
 *
 * Fields with no trigger equivalent (categories, transactionTypes, tags) are skipped.
 */
export function filtersToRulePresets(filters) {
    const triggers = [];
    // Search query → description trigger
    if (filters.searchQuery) {
        const mode = filters.searchMode ?? 'contains';
        triggers.push({
            triggerType: mode === 'notContains'
                ? TriggerType.DESCRIPTION_NOT_CONTAINS
                : TriggerType.DESCRIPTION_CONTAINS,
            triggerValue: filters.searchQuery,
        });
    }
    // Account filters → one ACCOUNT_IS trigger each
    if (filters.accountFilter?.length) {
        for (const accountId of filters.accountFilter) {
            triggers.push({
                triggerType: TriggerType.ACCOUNT_IS,
                triggerValue: accountId,
            });
        }
    }
    // Amount range
    if (filters.amountRange?.min != null) {
        triggers.push({
            triggerType: TriggerType.AMOUNT_GREATER_EQUAL,
            triggerValue: String(filters.amountRange.min),
        });
    }
    if (filters.amountRange?.max != null) {
        triggers.push({
            triggerType: TriggerType.AMOUNT_LESS_EQUAL,
            triggerValue: String(filters.amountRange.max),
        });
    }
    // Date range
    if (filters.dateRange?.from && filters.dateRange?.to) {
        triggers.push({
            triggerType: TriggerType.DATE_BETWEEN,
            triggerValue: `${new Date(filters.dateRange.from).toISOString()},${new Date(filters.dateRange.to).toISOString()}`,
        });
    }
    else if (filters.dateRange?.from) {
        triggers.push({
            triggerType: TriggerType.DATE_STARTING_FROM,
            triggerValue: new Date(filters.dateRange.from).toISOString(),
        });
    }
    else if (filters.dateRange?.to) {
        triggers.push({
            triggerType: TriggerType.DATE_UNTIL,
            triggerValue: new Date(filters.dateRange.to).toISOString(),
        });
    }
    return { triggers, actions: [] };
}
